(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["split-slideshow"] && !Shopify.designMode) return;
  try {
    
    (function(){
      var root = document.getElementById("split-{{ section.id }}");
      var grid = document.getElementById("grid-{{ section.id }}");
      if(!root || !grid) return;
      var left = document.getElementById("left-{{ section.id }}");
      var right = document.getElementById("right-{{ section.id }}");
      var mq = window.matchMedia("(max-width: 768px)");

      function setOverlay(panel, isMobile){
        if(!panel) return;
        var overlay = panel.querySelector('.panel__overlay');
        if(!overlay) return;
        var dimEnabled = panel.getAttribute('data-dim-enabled') === 'true';
        var dim = parseInt(isMobile ? (panel.getAttribute('data-mobile-dim') || panel.getAttribute('data-dim')) : panel.getAttribute('data-dim'), 10) || 0;
        var gradEnabled = panel.getAttribute('data-grad-enabled') === 'true';
        var angle = parseInt(panel.getAttribute('data-grad-angle') || '0',10);
        var gs = Math.max(0, Math.min(100, parseInt(panel.getAttribute('data-grad-start')||'0',10)));
        var ge = Math.max(0, Math.min(100, parseInt(panel.getAttribute('data-grad-end')||'0',10)));

        var bg = 'transparent';
        if(gradEnabled){
          bg = 'linear-gradient('+angle+'deg, rgba(0,0,0,'+(gs/100)+') 0%, rgba(0,0,0,'+(ge/100)+') 100%)';
        } else if(dimEnabled){
          bg = 'rgba(0,0,0,'+(dim/100)+')';
        }
        overlay.style.background = bg;
      }

      function setAutoContrast(panel, isMobile){
        var auto = panel.getAttribute('data-autocontrast') === 'true';
        var content = panel.querySelector('.panel__content');
        var heading = panel.querySelector('.panel__heading');
        if(!content || !heading) return;
        var dimEnabled = panel.getAttribute('data-dim-enabled') === 'true';
        var dim = parseInt(isMobile ? (panel.getAttribute('data-mobile-dim') || panel.getAttribute('data-dim')) : panel.getAttribute('data-dim'), 10) || 0;
        var gradEnabled = panel.getAttribute('data-grad-enabled') === 'true';
        var ge = parseInt(panel.getAttribute('data-grad-end') || '0',10);
        var desired = heading.style.getPropertyValue('--text');
        if(!desired || desired.trim() === ''){
          desired = getComputedStyle(content).getPropertyValue('--current-text') || '#ffffff';
        }
        var current = (desired.trim() || '#ffffff');
        if(auto){
          var darkness = gradEnabled ? ge : (dimEnabled ? dim : 0);
          current = darkness >= 45 ? '#ffffff' : '#111111';
        }
        content.style.setProperty('--current-text', current);
        content.style.color = current;
      }

      function applyPanelStyles(isMobile){
        [left, right].forEach(function(p){
          setOverlay(p, isMobile);
          setAutoContrast(p, isMobile);
        });
      }

      function onChange(e){ applyPanelStyles(e.matches); }
      document.addEventListener('shopify:section:load', function(){ applyPanelStyles(mq.matches); });
      document.addEventListener('shopify:section:select', function(){ applyPanelStyles(mq.matches); });
      // Initial
      applyPanelStyles(mq.matches);
      mq.addEventListener('change', onChange);

      // React to dynamic setting changes in Theme Editor
      var panels = [left, right];
      var observer = new MutationObserver(function(mutations){
        applyPanelStyles(mq.matches);
      });
      panels.forEach(function(p){
        if(!p) return;
        observer.observe(p, { attributes: true, attributeFilter: [
          'data-autocontrast','data-dim-enabled','data-dim','data-mobile-dim',
          'data-grad-enabled','data-grad-angle','data-grad-start','data-grad-end'
        ]});
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
